import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { IconButton } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';

import globals from '../../../globals/communityGlobals';
import { capitalFirstLetter } from '../../../utils/helpers';

class DateSelector extends React.Component {
  nextDate = () => {
    const date = moment(this.props.selectedDate)
      .add(1, 'days')
      .format(globals.dateFormats.date);

    this.refreshScheduler(date);
  };

  previousDate = () => {
    const date = moment(this.props.selectedDate)
      .subtract(1, 'days')
      .format(globals.dateFormats.date);

    this.refreshScheduler(date);
  };

  refreshScheduler = date => this.props.changeDate(date, this.props.currentPath);

  render() {
    return (
      <span className="day-nav">
        <IconButton aria-label="Back" onClick={this.previousDate} style={{ padding: '6px' }}>
          <span className="icon-extend icon-back-arrow" />
        </IconButton>
        <span className="day-object">
          <Typography variant="h6">
            {capitalFirstLetter(moment(this.props.selectedDate).format(globals.dateFormats.withWeekday))}
          </Typography>
        </span>

        <IconButton aria-label="Next" onClick={this.nextDate} style={{ padding: '6px' }}>
          <span className="icon-extend icon-next-arrow" />
        </IconButton>
      </span>
    );
  }
}

DateSelector.propTypes = {
  selectedDate: PropTypes.string.isRequired,
  changeDate: PropTypes.func.isRequired,
  currentPath: PropTypes.string.isRequired,
};

export default DateSelector;
